var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4105_84210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0849 10.8962C3.54998 9.60825 4.7724 8.75 6.1417 8.75H13.8583C15.2276 8.75 16.45 9.60825 16.9151 10.8962L18.3595 14.8962C19.1245 17.0146 17.5551 19.25 15.3027 19.25H4.69726C2.44495 19.25 0.875472 17.0146 1.64046 14.8962L3.0849 10.8962Z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4105_84210",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.79086 7.79086 1 10 1C12.2091 1 14 2.79086 14 5C14 7.20914 12.2091 9 10 9C7.79086 9 6 7.20914 6 5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5C8.61929 7.5 7.5 6.38071 7.5 5H4.5C4.5 8.03757 6.96243 10.5 10 10.5V7.5ZM12.5 5C12.5 6.38071 11.3807 7.5 10 7.5V10.5C13.0376 10.5 15.5 8.03757 15.5 5H12.5ZM10 2.5C11.3807 2.5 12.5 3.61929 12.5 5H15.5C15.5 1.96243 13.0376 -0.5 10 -0.5V2.5ZM10 -0.5C6.96243 -0.5 4.5 1.96243 4.5 5H7.5C7.5 3.61929 8.61929 2.5 10 2.5V-0.5Z",
    fill: "#197C85",
    mask: "url(#path-2-inside-1_4105_84210)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4105_84210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.2c24aca9527cf5652c347a0ba6dab516.svg";
export { ForwardRef as ReactComponent };